import { Student } from 'src/app/model/student/student.model';
import { MsgModel } from './../../../../common-components/msg/model/msg.model';
import { SchoolEnrollment } from './../../../model/school-enrollment.model';
import { StudentSchoolEnrollmentService } from './../../../service/student-school-enrollment.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'delete-child-enrollment-confirm-btn',
    templateUrl: './delete-child-enrollment-confirm-btn.component.html',
    styleUrls: ['./delete-child-enrollment-confirm-btn.component.scss']
})
export class DeleteChildEnrollmentConfirmBtnComponent implements OnInit {
    @Input() schoolEnrollments!: any[];
    @Input() students: Student[];

    @Input() type: string = 'icon';
    @Input() tooltip: string = '';
    @Input() icon: string = 'delete';
    @Input() color: string = 'warn';
    @Input() buttonTxt: string = 'Delete';
    @Input() popoverMsg: string = 'Confirm Delete';
    @Input() popoverConfirmText: string = 'Delete';
    @Input() popoverConfirmColor: string = 'warn';
    @Input() popoverCancelText: string = 'Cancel';
    @Input() popoverCancelColor: string = 'accent';
    @Input() disabled: boolean = false;
    @Input() class: string = '';

    @Output() onConfirm: EventEmitter<any> = new EventEmitter();

    @ViewChild('confirmElement') confirmElement!: MatButton;

    dataBsPopover: string = 'focus';

    @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;

    msg: MsgModel;

    doneLoading: boolean = false;
    isDeleting: boolean = false;
    isOpen: boolean = false;

    constructor(private studentSchoolEnrollmentService: StudentSchoolEnrollmentService) {}

    ngOnInit(): void {}

    delete() {
        if (this.schoolEnrollments && this.schoolEnrollments[0].ID) {
            this.isDeleting = true;
            this.msg = new MsgModel();

            let se: any = this.schoolEnrollments.map((se) => {
                return { ID: se.ID };
            });

            this.studentSchoolEnrollmentService.deleteSchoolEnrollment(se).subscribe({
                next: (res) => {
                    if (res.msg) {
                        if (res.msg.SUCCESS) {
                            this.msg = res.msg;

                            this.msg.MSG += ' (closing in 3 seconds...)';
                            setTimeout(() => {
                                this.onConfirm.emit(this.schoolEnrollments);
                                this.menuTrigger.closeMenu();
                            }, 3000);
                        } else {
                            this.msg = res.msg;
                        }
                    } else {
                        this.msg = { MSG: 'There was an error deleting this school enrollment', SUCCESS: false };
                    }
                },
                error: (err) => {
                    if (err.msg) {
                        this.msg = err.msg;
                    } else {
                        this.msg = { MSG: 'Server error.', SUCCESS: false };
                    }
                },
                complete: () => {
                    this.isDeleting = false;
                }
            });
        } else {
            this.msg = { MSG: 'No school enrollment to delete', SUCCESS: false };
            this.isDeleting = false;
        }
    }

    confirm() {
        this.delete();
    }

    openMenu() {
        //this.menuTrigger.openMenu();
        this.isOpen = true;
        this.confirmElement.focus();
    }

    closeMenu() {
        this.isOpen = false;
        this.menuTrigger.closeMenu();
    }

    setDoneLoading(doneLoading: boolean) {
        this.doneLoading = doneLoading;
        if (doneLoading) {
        }
    }
}
